import { TranslateLoader } from 'ng2-translate';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

export function createTranslateLoader(http: Http) {
    return new MultiTranslateHttpLoader(http, [
        {prefix: './assets/i18n/', suffix: '.json'},
        {prefix: './assets/i18n/socle.', suffix: '.json'}
      ]);
}

export class MultiTranslateHttpLoader implements TranslateLoader {

    constructor(private http: Http,
        public resources: { prefix: string, suffix: string }[] = [{
            prefix: '/assets/i18n/',
            suffix: '.json'
        }]) { }

    /**
     * Gets the translations from the server
     * @param lang
     * @returns {any}
     */
    public getTranslation(lang: string): any {

        return Observable.forkJoin(this.resources.map(config => {
            return this.http.get(`${config.prefix}${lang}${config.suffix}`);
        })).map(response => {
            return response.reduce((a: any, b: any) => {
                a._body = JSON.parse(a._body);
                b._body = JSON.parse(b._body);
                let obj: any = Object.assign(a._body, b._body);
                return obj;
            });
        });
    }
}


// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/services/custom-translate.service.ts